import { HttpUrlEncodingCodec } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ApiPartnerService } from '@app/api/api-partner.service';
import { ExcelServicesService } from '@app/_services/excel-service.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-adminreva-detail-cicilan',
  templateUrl: './adminreva-detail-cicilan.component.html',
  styleUrls: ['./adminreva.component.css']
})
export class AdminrevaDetailCicilanComponent implements OnInit {

  ListDetailcicilan: any = {};	
  ListCustfilter: any = {};	
  ListCustexport: any = {};	
  paging: any = {};	
  msearch : string;
  //paging_link : any = [];
  page_self = [];
  page_next = [];
  page_prev = [];
  last_index : number;
  first_index : number;
  total_count : number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = '';
  searchQueryParams = '';
  href='';
  alert_act='';
  alert_actmsg='';
  isprint='';
  sumSubs : any;
  summaryCicilan : any = [];
  detailcicilanpost: any;

  _STBdata: any = {
    'sn': ''
  };	
  
  table_load = false
  table_data = false
  table_filter = false
  isShow = false
  pagingshow = false
  printshow = false

  meta = [];
  self = [];
  excel = [];

  formFilter = this.fb.group({
    search_customerid : [''],
    // enddate: [''],
    // isprint: [''],
  });
  
  
  constructor(
    public partnerService: ApiPartnerService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private excelService:ExcelServicesService
  ) 

  {
    // this.partnerService.Listallcustfilter(this.formFilter.value).subscribe(output => {
    //   console.log(output)
    //   this.ListCustfilter = output
    //     this.ListCustfilter.data.forEach(row => {
    //       this.excel.push(row);
    //     });
    // });
  }

  ngOnInit() {
    this.loadStart();
    this.loadCicilan();
  }

  refreshPage() {
    this.isShow = false
    this.formFilter.reset()
    this.ngOnInit();
  }

  falset()
  {
    this.table_data = false
    this.table_filter = false
    this.pagingshow = false
    this.printshow = false
    this.table_load = true
  }

  _services(item: any)
  {
    let service = '';
    if ( item.services == null || item.services == 0 ){
      return service;
    }else{
      item.services.forEach(function (value: any) {
        service += value.servicename + '\n';
      });

      return service.replace(/(\\r\\n)|([\r\n])/gmi, ', ');
    }
  }
  
  isPairing(item: any)
  {
    return (item.services != null);
  }

  loadStart() {

    this.route.queryParams
      //.filter(params => params.order)
      .subscribe(params => {
        console.log(params.id) // {order: "popular"}
        //this.order = params.order;
        //console.log(this.order); // popular
        this.detailcicilanpost = {'date': params.date, 'id':params.id}
        console.log(this.detailcicilanpost)

        if (params.search != '' && params.search != undefined ){
          console.log('search');
          console.log(params.search);
         this.msearch = params.search; 
         this.querySearch = true;
        

         this.currentParams = params;
         this.queryParams = '?'+this.queryStr(params);
         this.loadsummary(this.queryParams, this.detailcicilanpost);
        
        }else{  
          this.querySearch = false;
          this.currentParams = params;

          this.queryParams = '?'+this.queryStr(params);
          console.log(this.queryParams);
          console.log(this.queryStr(params));
          /* pagination */
          //this.loadworkorder(this.currentParams);
          this.loadsummary(this.queryParams, this.detailcicilanpost);
        }
      });

    //this.table_load = true
    
  }

  loadsummary(queryParams: any, detailpost:any)
  {
    console.log(queryParams);
    this.falset()
    return this.partnerService.Viewsummarydetailcicilan(queryParams,detailpost).subscribe((output: any) => {
      this.ListDetailcicilan = output.data;
      this.sumSubs = output.summary;
      //console.log(output);
      this.table_load = false
      this.table_data = true
      this.pagingshow = true
      //this.customerid = this.ViewSTB.data.customer.id;

      this.paging = output.pagex;
      this.page_self = output.pagex.self;
      this.page_next = output.pagex.next;
      this.page_prev = output.pagex.prev;
      this.meta = output.meta;
      this.total_count = this.meta['totalCount'];
      let self = this.page_self['page'];
      if ( self * this.meta['perPage'] < this.meta['totalCount']){
        this.last_index = (self * this.meta['perPage']);
      }else{
        this.last_index = this.meta['totalCount'];
      }
      
      this.first_index = ((self-1)*this.meta['perPage'])+1;
      
    })


  }


  queryStr(options: any){
    let params = new URLSearchParams();
    for(let key in options){
        params.set(key, options[key]) 
    }
    return params.toString();
  }

  search()
  {
    this.msearch = this.formFilter.value.search_customerid;
    this.querySearch = true;
    this.searchQueryParams = this.queryParams+'&search='+this.msearch;
    this.loadsummary(this.searchQueryParams, this.detailcicilanpost);
    console.log(this.formFilter.value.search_customerid)
  }

  toggleshow()
  {
    this.isShow = !this.isShow
  }


  filterdate()
  {
    this.falset()
    return this.partnerService.Listallcustfilter(this.formFilter.value).subscribe((output: any) => {
      this.ListCustfilter = output.data;
      this.table_load = false
      this.pagingshow = false
      this.table_filter = true
      this.printshow = true
    })
  }
  
  loadCicilan()
  {
    return this.partnerService.Exportcicilansummary().subscribe((output: any) => {
      console.log(output);
      this.summaryCicilan = output;
      
    })
  }

}
